var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptiveflowspecDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 86 54",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 25.87,
    x2: 25.87,
    xlinkHref: "#adaptiveflowspec-dark_svg__a",
    y1: 4.627,
    y2: 47.403
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 25.296,
    x2: 25.296,
    xlinkHref: "#adaptiveflowspec-dark_svg__a",
    y1: -3.277,
    y2: 42.698
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 60.067,
    x2: 60.067,
    xlinkHref: "#adaptiveflowspec-dark_svg__b",
    y1: 49.346,
    y2: 6.57
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec-dark_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 60.642,
    x2: 60.642,
    xlinkHref: "#adaptiveflowspec-dark_svg__b",
    y1: 57.25,
    y2: 11.275
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "adaptiveflowspec-dark_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h86v54H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adaptiveflowspec-dark_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M55.367 0L21.309 33.763l6.291 6.19H2.437v-24.77l6.267 6.17L30.084 0H25.87L8.293 17.527-.062 9.303v33.025h33.548L25.1 34.075 59.714 0z",
    fill: "url(#adaptiveflowspec-dark_svg__d)",
    fillRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.96 33.387L51.52-.923 43.467-8.25 9.105 25.653 5.201 21.81v15.434h15.678z",
    fill: "url(#adaptiveflowspec-dark_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M30.57 53.974L64.629 20.21l-6.29-6.19H83.5v24.77l-6.267-6.169-21.38 21.352h4.215l17.577-17.527L86 44.671V11.645H52.451l8.388 8.253-34.615 34.075z",
    fill: "url(#adaptiveflowspec-dark_svg__f)",
    fillRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.978 20.587l-34.562 34.31 8.055 7.326L76.832 28.32l3.905 3.844V16.73H65.058z",
    fill: "url(#adaptiveflowspec-dark_svg__g)"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgAdaptiveflowspecDark as ReactComponent };